var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AdminFieldWrapper',{attrs:{"label":_vm.label || ''}},[_c('AdminInputRelated',_vm._g(_vm._b({attrs:{"btn-outlined":""}},'AdminInputRelated',Object.assign({}, _vm.$attrs, _vm.$props),false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }